<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <!-- <SearchBar class="mb-2" @search-clicked="searchClicked"></SearchBar> -->
            <CTableWrapper ref="table" hover striped :caption="$t('reviews')" :actions="actions" @action-clicked="actionClicked" :items="reviewitems" :pages="pages" :fields="reviewsFields" clickable-rows @row-clicked="reviewGroupClicked" @update-requested="updateItemsRequested" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
            </CTableWrapper>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

export default {
    extends: BasePopUp,
    components: {BasePopUp, CTableWrapper, SearchBar},
    props:{
        confirmationMessage:
        {
            type: String,
            default: ''
        },
        productId: Number
    },
    data () {
        return {
            searchText: '',
            currentPage: 1,
            itemsPerPage: localStorage.itemsPerPage ?? 10,
            reviewsFields: [ 
                { key: 'id', label: i18n.t('id'), _classes: 'font-weight-bold', sortable: true },
                { key: 'rating', label: i18n.t('rating'), _classes: 'font-weight-bold', sortable: true },
                { key: 'description', label: i18n.t('description'), sortable: true } 
            ],
            actions: [
                { key: 'approve', label: i18n.t('approve') },
                { key: 'remove', label: i18n.t('reproveRemove') },
            ],
            sorterValue: { column: 'id', asc: true },
            loading: false
        }
    },
    computed: {
        ...mapState('products', ['getProductsReviewsOutput']),
        ...mapState('products', ['approveProductReviewByIdOutput']),
        ...mapState('products', ['reproveProductReviewByIdOutput']),
        reviewInfo: function() {
            return this.getProductsReviewsOutput ? this.getProductsReviewsOutput : null;
        },
        reviewitems: function()
        {
            var result = [];

            if(this.reviewInfo && this.reviewInfo.data)
            {
                result = this.reviewInfo.data;

                result.forEach(review => {
                    // Actions
                    if(review.approved == true)
                    {
                        review["actions"] = [ { key: 'remove', label: i18n.t('reproveRemove') } ];   
                        review['_classes'] = "table-primary";
                    }else{
                        
                    }
                });
            }
            return result;
        },
        pages: function()
        {
            return this.reviewInfo ? this.reviewInfo.totalPages : 1;
        }
    },
    mounted: function()
    {
        this.updateItemsRequested(1, this.itemsPerPage);
    },
    methods:{
        ...mapActions('products', ['getProductsReviews']),
        ...mapActions('products', ['approveProductReviewsById']),
        ...mapActions('products', ['reproveProductReviewsById']),
        closeConfirmRequested(event)
        {       
            this.$emit("closeConfirmRequested");
        },
        reviewGroupClicked (item, index) {
            this.selectedFaqGroup = item;
        },
        updateItemsRequested(currentPage, itemsPerPage)
        {
            this.loading = true;
            //Make request
            this.itemsPerPage = itemsPerPage;
            this.currentPage = currentPage;

            var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));
            
            // List specific parameters
            if(this.productId)
            {
                input.productId =  this.productId;
            }

            this.getProductsReviews(input); 
        },
        sorterValueChanged(value)
        {
        this.sorterValue = value;
        },
        actionClicked(item, action){
            switch(action.key)
            {
                case 'approve':
                    {
                        if(confirm(this.$i18n.tc('confirmApproveReview', item.id, { id: item.id }))){
                            this.approveProductReviewsById(item.id);
                        }
                        break;
                    }
                case 'remove':
                    {
                        if(confirm(this.$i18n.tc('confirmReproveReview', item.id, { id: item.id }))){
                            this.reproveProductReviewsById(item.id);
                        }
                        break;
                    }
            }
        }
    },
    watch:
    {
        sorterValue:
        {
            handler: function(val)
            {
                this.updateItemsRequested(1, this.itemsPerPage);
            },
            deep: true // Watch for changes on the properties
        },
        getProductsReviewsOutput(val)
        {
            if(val != null)
            {
                this.loading = false;
            }
        },
        approveProductReviewByIdOutput(val)
        {
            this.loading = true;

            if(val)
            {
                this.updateItemsRequested(this.currentPage, this.itemsPerPage);
            }
        },
        reproveProductReviewByIdOutput(val)
        {
            this.loading = true;

            if(val)
            {
                this.updateItemsRequested(this.currentPage, this.itemsPerPage);
            }
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }
    /deep/.table th
    {
        border-top: none;
    }

    /deep/.table tr
    {
        cursor: pointer;
    }
    >>>.table-primary > td
    {
        background-color: unset!important;    
    }
    >>>.table-primary
    {
        background-color: greenyellow!important;    
    }
    >>>.table-hover .table-primary:hover {
        background-color: greenyellow!important;
    }
    >>>.table-primary td{
        border: transparent;
    }
    >>>.table td{
        border: transparent;
    }
</style>